let TravelService = {
    getSavedTravelers() {
        return axios.get('/asigurare-de-calatorie/travelers')
    },
    saveTravelers(data) {
        return axios.post('/asigurare-de-calatorie/travelers', {travelers: data})
    },
    fetchCollector() {
        return axios.get('/csr/collector');
    },
    isLoggedIn() {
        return axios.get('/is-logged-in');
    },
    fetchProviders() {
        return axios.get('/csr/travel-providers');
    },
    fetchQuotation(data) {
        return axios.post('/csr/travel-quotation', data);
    },
    fetchCounties() {
        return axios.get('/csr/utility/county');
    },
    fetchCities(countyId) {
        return axios.get('/csr/utility/locality?county_id='+countyId);
    },
    register(email) {
        return axios.post('/quick-register', {email: email});
    },
    login(data) {
        return axios.post('/travel-login', data);
    },
    forgot_password(data) {
        return axios.post('/travel-forgot-password', data);
    },
    order(data) {
        return axios.post('/csr/travel-order', data);
    },
    fetchEuroinsBrands() {
        return axios.get('/csr/utility/euroins-brands');
    },
    collect(data) {
        return axios.post('/csr/collect', {data: data})
    },
    initQuotations() {
        return axios.post('/csr/travel-init-quotations');
    },
}

export default TravelService;